import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=48927fe6&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=48927fe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48927fe6",
  null
  
)

export default component.exports